import { type UserAccessActions, UserAccessActionTypes, lifeHomeActionTypes, lifeHomeActions } from './actions';
import { UserAccess, lifehomeProps } from './context';

export const reducer = (state: UserAccess, action: UserAccessActions): UserAccess => {
  switch (action.type) {
    case UserAccessActionTypes.REFRESH:
      return {
        ...state,
        ...action.payload,
      };
    case UserAccessActionTypes.LOGOUT:
      return {};
    default:
      return state;
  }
};

export const lifeHomeReducer = (state: lifehomeProps, action: lifeHomeActions): lifehomeProps => {
  switch (action.type) {
    case lifeHomeActionTypes.REFRESH:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
